module.exports = __webpack_public_path__ + "img/duracion_largos_seleccionado.e76b5df5.png";